import { ILoyaltyProgramDTO, ILoyaltyProgramEditDTO, ILoyaltyProgramViewDTO } from "../../coreapi-dto/dirs/loyaltyProgram";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";


interface ILoyaltyProgramCreate extends ILoyaltyProgramViewDTO {
}
interface ILoyaltyProgramUpdate extends ILoyaltyProgramEditDTO {
}

class LoyaltyProgramRequest extends BaseDirRequest<ILoyaltyProgramViewDTO, ILoyaltyProgramEditDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "LoyaltyPrograms", token, eventHandler)
    }
    
    create(body: ILoyaltyProgramCreate, callback: (e:CoreApiResponse<string>) => void) {
        super.create(body, callback)
    }

    update(idGlobal: string, body: ILoyaltyProgramEditDTO, callback: (e:CoreApiResponse<null>) => void) {
        super.update(idGlobal, body, callback)
    }
}
export default LoyaltyProgramRequest